import PrintGrossProfitMarginPreview from "./GrossProfitMarginPreview";

const PrintGrossProfitMargin: React.FC = () => {
  return (
    <div className="inner-container">
      <PrintGrossProfitMarginPreview />
    </div>
  );
};

export default PrintGrossProfitMargin;
